import React, { useEffect, useState } from 'react';
import Access from "../../Components/Access";
import Navbar from "../../Components/Navbar";
import NavbarAdmin from "../../Components/NavbarAdmin";
import axios from 'axios';
import qs from 'qs';
import {NotificationManager} from 'react-notifications';
import Dialog from '../../Components/Dialog';


const Application = (props) =>
{
    const [aff, setAff] = useState(false);
    const [liste, setListe] = useState([]);
    const heightObject = window.innerHeight/1.9;
    const [messagesAccueil, setMessagesAccueil] = useState([]);
    const [newMessageText, setNewMessageText] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [editingText, setEditingText] = useState('');
    const [creating, setCreating] = useState(false);
    const [phrase_id, setPhraseId] = useState(null);

    const purple = '#6571FE';
    const green = '#59B44A';
    const blue = '#069BD3';

    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    async function callbackDialog(ret) {
        if (ret === true) {
            await suppress();
        }
    }


    useEffect(() => {
        axios.get('https://app-slfinance.fr/api/application.php?access_token=StrategiesLocales')
        .then(async function (res) {
            var tmp = [];
            for(var line in res.data) {
                tmp.push([line, res.data[line]]);
            }
            await setListe(tmp);
            await setAff(!aff);
        })
        .catch((err) => {
            console.warn(err);
        })

        // fetch messages d'accueil
        axios.post('https://app-slfinance.fr/api/messages_accueil.php', qs.stringify({'get': true}))
        .then((res) => {
            if (Array.isArray(res.data)) setMessagesAccueil(res.data);
        })
        .catch((err) => console.warn(err));
    }, [])

    async function suppress()
    {
        if (phrase_id === null) {
            return;
        }
        const param = {'delete': true, 'id': phrase_id};
        await axios.post('https://app-slfinance.fr/api/messages_accueil.php', qs.stringify(param));
        setMessagesAccueil(messagesAccueil.filter(x => x.id !== phrase_id));
        NotificationManager.success('Phrase supprimée', '', 1500);
        setPhraseId(null);
    }

	return (
        <Access needConnection={true} type_user={[1]}>
            <Navbar />
            <NavbarAdmin />

            <Dialog
                setModalVisible={setDialogModalVisible}
                modalVisible={dialogModalVisible}
                callbackDialog={callbackDialog}
                message={"Confirmez la suppression"}
            />

            <div style={{display: 'flex', margin: 25}}>
                <p>Paramètre \</p>
                <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Application</p>
            </div>


            <div className='shadow-md rounded-md' style={{margin: 50}}>
                <div style={{overflowY: 'scroll'}}>
                    <div style={{display: 'flex', backgroundColor: blue, borderTopLeftRadius: 5, borderTopRightRadius: 5, color: 'white'}}>
                        <div style={{flex: 0.5, textAlign: 'center'}}>
                            <p>Champ</p>
                        </div>
                        
                        <div style={{flex: 1, textAlign: 'center'}}>
                            <p>Valeur</p>
                        </div>
                    </div>
                </div>

                <div style={{overflowY: 'scroll', maxHeight: heightObject}}>
                    {liste.map((line, i) =>
                    <div key={i} style={{display: 'flex'}}>
                        <div style={{flex: 1, display: 'flex', borderBottom: '1px solid '+blue}}>
                            <div style={{flex: 0.5, textAlign: 'right', borderLeft: '1px solid '+blue, marginRight: 5}}>
                                <p>{line[0]}</p>
                            </div>
                            <div style={{display: 'flex', flex: 1, borderLeft: '1px solid white', borderLeft: '1px solid '+blue}}>
                                <input
                                style={{flex: 1, paddingLeft: 5}}
                                placeholder={line[1]}
                                onBlur={async (e) => {
                                    if (e.target.value !== '') {

                                        var param = {
                                            'set_application': true,
                                            'parametre': line[0],
                                            'valeur': e.target.value
                                        }
                                        await axios.post('https://app-slfinance.fr/api/application.php', qs.stringify(param))
                                        .then(async (res) => {
                                            if (res.data['status'] === 1) {
                                                NotificationManager.success(res.data['status_message'], '', 2000);
                                                var tmp = liste;
                                                await tmp.forEach((element, i) => {
                                                    if (element[0] === line[0]) {
                                                        tmp[i][1] = e.target.value;
                                                        e.target.value = '';
                                                    }
                                                });
                                                await setListe(tmp);
                                                await setAff(!aff);
                                            }
                                            else {
                                                NotificationManager.warning(res.data['status_message'], '', 2000);
                                            }
                                        })
                                        .catch((err) => {
                                            console.warn(err)
                                        })

                                    }
                                }}
                                />
                            </div>
                        </div>
                    </div>
                    )}

                </div>


            </div>

            <div style={{display: 'flex', margin: 25}}>
                <p>Phrases d'accueil :</p>
            </div>

            <div className='shadow-md' style={{margin: '0 50px 20px 50px', padding: 12, borderRadius: 6, background: 'white'}}>
                <div style={{display: 'flex', gap: 8, marginBottom: 10}}>
                    <input
                        style={{flex: 1, padding: 8, borderRadius: 6, border: '1px solid #E9ECEF'}}
                        placeholder="Nouvelle phrase d'accueil"
                        value={newMessageText}
                        onChange={(e) => setNewMessageText(e.target.value)}
                    />
                    <button
                        onClick={async () => {
                            if (!newMessageText.trim() || creating) return;
                            setCreating(true);
                            try {
                                const param = {'create': true, 'message': newMessageText.trim()};
                                const res = await axios.post('https://app-slfinance.fr/api/messages_accueil.php', qs.stringify(param));
                                console.log('create res', res.data);
                                if (res.data?.status === 1) {
                                    NotificationManager.success(res.data.message || 'Phrase créée', '', 1500);
                                    // refresh list locally
                                    setMessagesAccueil([{id: res.data.id, message: newMessageText.trim()}, ...messagesAccueil]);
                                    setNewMessageText('');
                                } else {
                                    const msg = res.data?.message || JSON.stringify(res.data) || 'Erreur';
                                    NotificationManager.warning(msg, '', 3000);
                                }
                            } catch (err) {
                                console.warn('create error', err);
                                const serverMsg = err.response?.data ? (err.response.data.message || JSON.stringify(err.response.data)) : err.message;
                                NotificationManager.error('Erreur création: ' + serverMsg, '', 4000);
                            } finally {
                                setCreating(false);
                            }
                        }}
                        style={{padding: '8px 12px', borderRadius: 6, background: green, color: 'white', border: 'none'}}
                    >
                        {creating ? '...' : 'Ajouter'}
                    </button>
                </div>

                {messagesAccueil.length ? (
                    <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
                        {messagesAccueil.map((m) => (
                            <div key={m.id} style={{padding: 8, borderRadius: 6, border: '1px solid #F0F2F5', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                <div style={{flex: 1}}>
                                    {editingId === m.id ? (
                                        <input
                                            style={{width: '100%', padding: 6, borderRadius: 4, border: '1px solid #E9ECEF'}}
                                            value={editingText}
                                            onChange={(e) => setEditingText(e.target.value)}
                                        />
                                    ) : (
                                        <p style={{}}>{m.message}</p>
                                    )}
                                </div>
                                <div style={{display: 'flex', gap: 8, marginLeft: 12}}>
                                    {editingId === m.id ? (
                                        <>
                                        <button
                                            onClick={async () => {
                                                // save
                                                try {
                                                    const param = {'set': true, 'id': m.id, 'message': editingText};
                                                    const res = await axios.post('https://app-slfinance.fr/api/messages_accueil.php', qs.stringify(param));
                                                    NotificationManager.success('Phrase modifiée', '', 1500);
                                                    setMessagesAccueil(messagesAccueil.map(x => x.id === m.id ? {...x, message: editingText} : x));
                                                    setEditingId(null);
                                                    setEditingText('');
                                                } catch (err) { console.warn(err); }
                                            }}
                                            style={{padding: '6px 10px', borderRadius: 4, background: '#59B44A', color: 'white', border: 'none'}}
                                        >Enregistrer</button>
                                        <button
                                            onClick={() => { setEditingId(null); setEditingText(''); }}
                                            style={{padding: '6px 10px', borderRadius: 4, background: '#F0F2F5', border: 'none'}}
                                        >Annuler</button>
                                        </>
                                    ) : (
                                        <>
                                        <button
                                            onClick={() => { setEditingId(m.id); setEditingText(m.message); }}
                                            style={{padding: '6px 10px', borderRadius: 4, background: 'orange', color: 'white', border: 'none'}}
                                        >Modifier</button>
                                        <button
                                            onClick={async () => {
                                                setPhraseId(m.id);
                                                setDialogModalVisible(true);
                                            }}
                                            style={{padding: '6px 10px', borderRadius: 4, background: 'red', color: 'white', border: 'none'}}
                                        >Supprimer</button>
                                        </>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div style={{padding: 12, color: '#999'}}>Aucune phrase d'accueil enregistrée.</div>
                )}
            </div>


            <div style={{display: 'flex', margin: 25}}>
                <p>Liens utiles :</p>
            </div>

            <div style={{display: 'flex', marginLeft: 50}}>
                <p>- INSEE :</p>
                <a style={{color: 'blue', marginLeft: 5}} href="https://api.insee.fr/catalogue/site/themes/wso2/subthemes/insee/pages/item-info.jag?name=Sirene&version=V3.11&provider=insee">
                https://api.insee.fr
                </a>
            </div>

            <div style={{display: 'flex', marginLeft: 50}}>
                <p>- FISCALITE (REI) :</p>
                <a style={{color: 'blue', marginLeft: 5}} href="https://data.economie.gouv.fr/explore/dataset/impots-locaux-fichier-de-recensement-des-elements-dimposition-a-la-fiscalite-dir/information/">
                https://data.gouv.fr
                </a>
            </div>

            <div style={{display: 'flex', marginLeft: 50}}>
                <p>- BALANCES COMPTABLES :</p>
                <a style={{color: 'blue', marginLeft: 5}} href="https://www.data.economie.gouv.fr/explore/dataset/balances-comptables-des-communes-en-2023/api/">
                https://data.economie.gouv.fr
                </a>
            </div>

            <div style={{display: 'flex', marginLeft: 50}}>
                <p>- GITHUB :</p>
                <a style={{color: 'blue', marginLeft: 5}} href="https://github.com/login">
                https://github.com
                </a>
            </div>

            <div style={{height: 50}}></div>

        </Access>
	);
}


export default Application;
